import axios from 'api/axios'
import handleAxiosError from 'utils/handleAxiosError'

/**
 * Type Interface of objects that can be used in the API for editAdmin
 */

export interface editAdminBody {
	firstName: string
	lastName: string
	email: string
	mobile: string
	password: string | null
	active: boolean
}
interface editAdminProps {
	id: string
	body: editAdminBody
}

/**
 * Type Interface for the Response object you get from editAdmin request if successful
 */
export interface EditAdminsResponse {
	statusCode: number
	message: string
}

/**
 * API call to update Admin in AdminPageLayout
 * @param options AddAdminsParams - Options for the API call
 * @returns AdminResponse - Response object returned from the server
 */

export const editAdmin = async ({ id, body }: editAdminProps) => {
	try {
		const { data } = await axios.patch<EditAdminsResponse>(
			`management/user/${id}`,
			body
		)

		return data
	} catch (error: any) {
		handleAxiosError(error)
		throw error
	}
}

export default editAdmin
